export default __webpack_public_path__ + "static/media/compatible-vtex.baa2a611.svg";